const STUDENT_SESSION_KEY = "mu_convocation_student";

export function getStudentSession() {
  try {
    const raw = sessionStorage.getItem(STUDENT_SESSION_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (session.expires_at && Date.now() / 1000 > session.expires_at) {
      clearStudentSession();
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

export function setStudentSession(session) {
  sessionStorage.setItem(STUDENT_SESSION_KEY, JSON.stringify(session));
}

export function clearStudentSession() {
  sessionStorage.removeItem(STUDENT_SESSION_KEY);
}

export function captureStudentTokenFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("student_token");
  const exp = Number(params.get("student_exp") || 0);
  if (!token) return false;
  setStudentSession({
    token,
    expires_at: exp || undefined,
    email: params.get("student_email") || undefined,
  });
  params.delete("student_token");
  params.delete("student_exp");
  params.delete("student_email");
  const qs = params.toString();
  const next = `${window.location.pathname}${qs ? `?${qs}` : ""}`;
  window.history.replaceState({}, "", next);
  return true;
}
